import type BaseObject from "../models/BaseObject";
import type BaseModel from "../models/BaseModel";

export type ConnectionSelectionRole = "primary" | "secondary";

/** Buttons select all channel connections; actors retain the existing analysis as secondary containers. */
export function connectionSelectionRole(object: BaseObject): ConnectionSelectionRole {
  const model = object as Partial<BaseModel>;
  return model.isConnectableObject === true && model.isActor !== true
    ? "primary"
    : "secondary";
}
